module.exports = __webpack_public_path__ + "static/media/youtube-icon.8281d6c5.svg";